import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <div className="auth-page">
      <div className="not-found">
        <p className="not-found-code">404</p>
        <h2>Page Not Found</h2>
        <p>The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn-secondary">Go Home</Link>
      </div>
    </div>
  );
}
